import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import DataTable from "react-data-table-component";
import { Badge, Button, Modal, Form } from "react-bootstrap";
import SetPaidDisbursementModal from "./SetPaidDisbursementModal";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

const SalaryPage = () => {
  //const [salaries, setSalaries] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [formData, setFormData] = useState({
    officer_id: "",
    amount: "",
    description: "",
  });
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedDetail, setSelectedDetail] = useState(null);
  const [salaries, setSalaries] = useState([]);
  const UPLOADS_BASE = (API_URL || "").replace(/\/api\/?$/, "") || API_URL;
  const [channels, setChannels] = useState([]);
  const [sisaBudgetGaji, setSisaBudgetGaji] = useState(0);
  const [disbursements, setDisbursements] = useState([]);
  const [showSetPaidModal, setShowSetPaidModal] = useState(false);
  const [selectedDisbursement, setSelectedDisbursement] = useState(null);

  const [officers, setOfficers] = useState([]);
  const fetchData = async () => {
    try {
      const token = localStorage.getItem("token");
      const [salariesRes, disbursementsRes] = await Promise.all([
        axios.get(`${API_URL}/api/salaries/officer`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${API_URL}/api/disbursements`, { headers: { Authorization: `Bearer ${token}` } }),
      ]);
      setSalaries(salariesRes.data);
      setDisbursements(disbursementsRes.data);
    } catch (err) {
      console.error("Failed to fetch data", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const fetchOfficers = async () => {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/officers`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setOfficers(res.data);
    };

    const fetchChannels = async () => {
      const token = localStorage.getItem("token");
      try {
        const res = await axios.get(`${API_URL}/api/finance/channels`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setChannels(res.data);
      } catch (err) {
        console.error("Failed to fetch channels", err);
      }
    };

    const fetchFinanceSummary = async () => {
      const token = localStorage.getItem("token");
      try {
        const res = await axios.get(`${API_URL}/api/finance/summary`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.data && res.data.total) {
          setSisaBudgetGaji(res.data.total.sisa_budget_gaji || 0);
        }
      } catch (err) {
        console.error("Failed to fetch finance summary", err);
      }
    };

    fetchData();
    fetchOfficers();
    fetchChannels();
    fetchFinanceSummary();
  }, []);

  const pendingDisbursements = disbursements.filter((d) => d.status === "pending");
  const paidDisbursements = disbursements.filter((d) => d.status === "paid");




  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const amountVal = parseFloat(formData.amount || 0);
      if (!editData && amountVal > sisaBudgetGaji) {
        return Swal.fire("Validasi Gagal", `Jumlah gaji melebihi sisa uang untuk gaji (${formatRupiah(sisaBudgetGaji)})`, "error");
      }

      const token = localStorage.getItem("token");
      if (editData) {
        await axios.post(`${process.env.REACT_APP_API_URL}/api/salaries/update/${editData.id}`, formData, {
          headers: { Authorization: `Bearer ${token}` },
        });
        Swal.fire("Updated!", "Salary updated successfully", "success");
      } else {
        await axios.post(`${process.env.REACT_APP_API_URL}/api/salaries`, formData, {
          headers: { Authorization: `Bearer ${token}` },
        });
        Swal.fire("Added!", "Salary created successfully", "success");
      }
      fetchData();

      // Re-fetch finance summary to update budget UI
      const tokenAuth = localStorage.getItem("token");
      const summaryRes = await axios.get(`${process.env.REACT_APP_API_URL}/api/finance/summary`, {
        headers: { Authorization: `Bearer ${tokenAuth}` },
      });
      if (summaryRes.data && summaryRes.data.total) {
        setSisaBudgetGaji(summaryRes.data.total.sisa_budget_gaji || 0);
      }

      setShowModal(false);
      setEditData(null);
    } catch (err) {
      Swal.fire("Error", err.response?.data?.error || "Failed to save salary", "error");
    }
  };


  const formatRupiah = (value) => {
    // Konversi ke float lalu buang desimal
    const floatValue = parseFloat(value);
    const intValue = Math.floor(floatValue); // atau Math.round(floatValue) kalau mau dibulatkan

    if (isNaN(intValue)) return "Rp 0";

    return `Rp ${intValue.toLocaleString("id-ID")}`;
  };





  const unformatRupiah = (value) => {
    return value.replace(/\D/g, "");
  };




  const handleShowDetail = (row) => {
    setSelectedDetail(row);
    setShowDetailModal(true);
  };



  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This will delete the salary record.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });
    if (confirm.isConfirmed) {
      const token = localStorage.getItem("token");
      try {
        await axios.post(`${process.env.REACT_APP_API_URL}/api/salaries/delete/${id}`, {}, {
          headers: { Authorization: `Bearer ${token}` },
        });
        Swal.fire("Deleted!", "Salary deleted.", "success");
        fetchData();
      } catch (err) {
        Swal.fire("Error", "Failed to delete salary.", "error");
      }
    }
  };

  const payrollTypeLabel = (v) => (v === "bank" ? "Bank" : v === "e_wallet" ? "E-Wallet" : v || "-");

  return (
    <div>
      <h2>Salary Management</h2>
      <Button className="mb-4" onClick={() => { setEditData(null); setFormData({ officer_id: "", amount: "", description: "" }); setShowModal(true); }}>
        Add Salary
      </Button>

      {/* 1. Pengajuan Pencairan (Pending) */}
      <div className="mb-5">
        <h5>Pengajuan Pencairan</h5>
        <DataTable
          columns={[
            { name: "Officer", selector: (r) => `${r.full_name} (${r.position} - ${r.division})`, sortable: true },
            { name: "Nominal", selector: (r) => formatRupiah(r.amount), sortable: true },
            { name: "Payroll", selector: (r) => `${payrollTypeLabel(r.payroll_type)} - ${r.payroll_account}` },
            { name: "Tanggal Ajuan", selector: (r) => new Date(r.request_date).toLocaleDateString("id-ID") },
            {
              name: "Aksi",
              cell: (r) => (
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => {
                    setSelectedDisbursement(r);
                    setShowSetPaidModal(true);
                  }}
                >
                  Set Paid
                </Button>
              ),
            },
          ]}
          data={pendingDisbursements}
          pagination
          highlightOnHover
          responsive
          noDataComponent="Belum ada pengajuan pencairan."
        />
      </div>

      {/* 2. Gaji Terinput */}
      <div className="mb-5">
        <h5>Gaji Terinput</h5>
        <DataTable
          columns={[
            { name: "Officer", selector: (r) => `${r.full_name} (${r.position} - ${r.division})`, sortable: true },
            { name: "Jumlah", selector: (r) => formatRupiah(r.amount), sortable: true },
            { name: "Deskripsi", selector: (r) => r.description || "-" },
            { name: "Tanggal Input", selector: (r) => new Date(r.input_date).toLocaleDateString("id-ID") },
            {
              name: "Aksi",
              cell: (r) => (
                <>
                  <Button variant="info" size="sm" className="me-2" onClick={() => handleShowDetail(r)}>Detail</Button>
                  <Button variant="warning" size="sm" className="me-2" onClick={() => { setEditData(r); setFormData(r); setShowModal(true); }}>Edit</Button>
                  <Button variant="danger" size="sm" onClick={() => handleDelete(r.id)}>Delete</Button>
                </>
              ),
            },
          ]}
          data={salaries}
          pagination
          highlightOnHover
          responsive
          noDataComponent="Belum ada gaji terinput."
        />
      </div>

      {/* 3. Gaji Terbayarkan */}
      <div className="mb-5">
        <h5>Gaji Terbayarkan</h5>
        <DataTable
          columns={[
            { name: "Officer", selector: (r) => `${r.full_name} (${r.position} - ${r.division})`, sortable: true },
            { name: "Nominal", selector: (r) => formatRupiah(r.amount), sortable: true },
            { name: "Payroll", selector: (r) => `${payrollTypeLabel(r.payroll_type)} - ${r.payroll_account}` },
            { name: "Tanggal Ajuan", selector: (r) => new Date(r.request_date).toLocaleDateString("id-ID") },
            { name: "Tanggal Bayar", selector: (r) => (r.paid_date ? new Date(r.paid_date).toLocaleDateString("id-ID") : "-") },
            {
              name: "Bukti",
              cell: (r) =>
                r.attachment ? (
                  <a href={`${UPLOADS_BASE}/uploads/${r.attachment}`} target="_blank" rel="noopener noreferrer">
                    Lihat Bukti
                  </a>
                ) : (
                  "-"
                ),
            },
          ]}
          data={paidDisbursements}
          pagination
          highlightOnHover
          responsive
          noDataComponent="Belum ada gaji terbayarkan."
        />
      </div>

      <SetPaidDisbursementModal
        show={showSetPaidModal}
        onHide={() => { setShowSetPaidModal(false); setSelectedDisbursement(null); }}
        item={selectedDisbursement}
        channels={channels}
        onSuccess={fetchData}
      />

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{editData ? "Edit Salary" : "Add Salary"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="bg-blue-50 text-blue-800 border-l-4 border-blue-500 p-3 mb-4 rounded shadow-sm text-sm">
            <strong>Sisa uang untuk gaji: </strong> {formatRupiah(sisaBudgetGaji)}
          </div>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Officer</Form.Label>
              <Form.Select
                name="officer_id"
                value={formData.officer_id}
                onChange={handleChange}
                required
              >
                <option value="">-- Pilih Officer --</option>
                {officers.map((officer) => (
                  <option key={officer.id} value={officer.id}>
                    {officer.full_name} ({officer.position} - {officer.division})
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Amount</Form.Label>
              <Form.Control
                type="text"
                name="amount"
                value={formatRupiah(formData.amount)}
                onChange={(e) => {
                  const raw = unformatRupiah(e.target.value);
                  setFormData((prev) => ({ ...prev, amount: raw }));
                }}
                required
              />

            </Form.Group>


            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                type="text"
                name="description"
                value={formData.description}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <div className="d-flex justify-content-end">
              <Button variant="secondary" onClick={() => setShowModal(false)} className="me-2">
                Cancel
              </Button>
              <Button type="submit" variant="primary">
                {editData ? "Update" : "Add"} Salary
              </Button>
            </div>
          </Form>

        </Modal.Body>
      </Modal>

      <Modal show={showDetailModal} onHide={() => setShowDetailModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Detail Gaji Terinput</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedDetail && (
            <div>
              <p><strong>Officer:</strong> {selectedDetail.full_name} ({selectedDetail.position} - {selectedDetail.division})</p>
              <p><strong>Payroll Account:</strong> {selectedDetail.payroll_account || "-"}</p>
              <p><strong>Jumlah:</strong> {formatRupiah(selectedDetail.amount)}</p>
              <p><strong>Deskripsi:</strong> {selectedDetail.description || "-"}</p>
              <p><strong>Tanggal Input:</strong> {new Date(selectedDetail.input_date).toLocaleDateString("id-ID")}</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDetailModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};

export default SalaryPage;
